'use client'
import React from 'react'
import { useFormik } from 'formik'
import { contactValidationSchema } from '@/src/validations/formvalidations'
import { usePostContactUsMutation } from '@/src/store/rtkQueries/userPostAPI'
import { toast } from '@/src/lib/toast'

export default function ContactForm() {
  const [postContactUs] = usePostContactUsMutation()

  const { values, errors, touched, handleChange, handleBlur, handleSubmit, isSubmitting } = useFormik({
    initialValues: {
      name: '',
      email: '',
      message: '',
    },
    validationSchema: contactValidationSchema,
    onSubmit: async (values, { resetForm }) => {
      try {
        const response = await postContactUs(values).unwrap()
        toast.success(response.message || 'Message sent successfully')
        resetForm()
      } catch (error: unknown) {
        console.error('Error submitting contact form', error)
        toast.danger('Failed to send message. Please try again.')
      }
    },
  })

  return (
    <>
        <div className="border border-muted-color rounded-2xl px-6 py-5">
            <form onSubmit={handleSubmit} className="space-y-4">
              <div className="two_column_form">
                <div className="input_container">
                  <label className="form_label" htmlFor="contact-name">
                    Name <span className="required_field">*</span>
                  </label>
                  <input
                    id="contact-name"
                    name="name"
                    type="text"
                    value={values.name}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    placeholder="Enter your name"
                    className="form_input"
                  />
                  {errors.name && touched.name && (
                    <p className="error_text">{errors.name}</p>
                  )}
                </div>
        
                <div className="input_container">
                  <label className="form_label" htmlFor="contact-email">
                    Email <span className="required_field">*</span>
                  </label>
                  <input
                    id="contact-email"
                    name="email"
                    type="email"
                    value={values.email}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    placeholder="Enter your email"
                    className="form_input"
                  />
                  {errors.email && touched.email && (
                    <p className="error_text">{errors.email}</p>
                  )}
                </div>
              </div>
        
              <div className="input_container">
                <label className="form_label" htmlFor="contact-message">
                  Message <span className="required_field">*</span>
                </label>
                <textarea
                  id="contact-message"
                  name="message"
                  rows={5}
                  value={values.message}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  placeholder="Write here"
                  className="form_input resize-none"
                />
                {errors.message && touched.message && (
                  <p className="error_text">{errors.message}</p>
                )}
              </div>
        
              <button
                type="submit"
                disabled={isSubmitting}
                className="bg-body-color text-white text-xs font-semibold tracking-widest uppercase rounded-full px-8 py-3 hover:opacity-80 transition-opacity cursor-pointer disabled:opacity-50 disabled:cursor-not-allowed"
              >
                {isSubmitting ? 'Sending…' : 'Submit'}
              </button>
            </form>
        </div>
    </>
  )
}
